<script setup lang="ts">
import consola from 'consola'

const { recipes = [] } = defineProps<{ recipes: _CookBookItem[] }>()

const { t } = useI18n()
const localPath = useLocalePath()
const authStore = useAuthStore()
const nuxtApp = useNuxtApp()

const userinfo = computed(() => {
  try {
    return nuxtApp.$userinfo
  }
  catch (error) {
    consola.error(error)

    return authStore.userinfo
  }
})

function handleIconClick(item: _CookBookItem) {
  navigateTo(localPath(`/recipe/form/${item.id}`))
}

function toDetail(id: number) {
  navigateTo(localPath(`/recipe/${id}`))
}
</script>

<template>
  <div
    v-for="item in recipes"
    :key="item.id"
    class="product-item"
  >
    <div class="cover">
      <img
        aspect-square w-full
        :src="item.coverImgUrl || '/images/default/detailt-product.jpeg'"
        :alt="item.name"
        @click="toDetail(item.id)"
      >
      <div v-if="userinfo?.id && item.userId === userinfo?.id" class="i-mi-edit-alt absolute right-0 top-0 text-xl text-theme" @click="handleIconClick(item)" />
    </div>
    <div
      mt-1
      px-2
      class="product-name"
    >
      {{ item.name }}
    </div>
    <div

      mt-1 w-full flex items-center justify-between px-2 font-size-12px
    >
      <div
        flex basis-auto items-center whitespace-nowrap
      >
        <div
          mr-0.5
          style="color: #743a3a"
        >
          {{ t('pages.recipe.difficulty') }}
        </div>
        <div class="w-15 flex flex-row flex-nowrap">
          <template v-for="i in (item.difficult >= 5 ? 5 : item.difficult)" :key="i">
            <svgo-RiStarFill class="text-3 text-theme" />
          </template>
        </div>
      </div>
      <div
        flex basis-auto items-center
      >
        <svgo-integrals
          filled
          class="text-xs"
        />
        <div>
          <span>{{ item.watchPoints }}</span>
          <span class="text-10px">{{ t('integral') }}</span>
        </div>
      </div>
    </div>
    <div

      my-2 flex justify-between px-2
      style="color: #743a3a"
    >
      <div
        flex
        items-center
        font-size-13px
      >
        <svgo-time />
        <div>{{ item.cookingTime }}分鐘</div>
      </div>
      <div
        flex
        items-center
        font-size-13px
      >
        <svgo-RiEyeFill class="text-theme" />
        <div ml-1>
          {{ item.clickCount }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.product-item {
  background-color: #fff;
  border-radius: 10px;
  height: min-content;
  overflow-x: hidden;
  img {
    border-radius: 10px;
  }
  .product-name {
    font-size: 15px;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 160px;
    display: block;
  }
  .cover {
    position: relative;
  }
}
.floating-bubble {
  width: 100%;
  height: 100%;
}
</style>
